export default __webpack_public_path__ + "static/media/cubetimmer.3dfdd483.png";